import { Suspense, lazy } from "react";
import Loader from "../customs/Customspinner/spinner";

const Main = lazy(() => import("../components/forgotPassword/forgotPassword"));

const ForgotPassword = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default ForgotPassword;
